import * as constant from './constant'

export default {
    constant
}
